import { render, staticRenderFns } from "./account-pop-up.vue?vue&type=template&id=2071b714&"
import script from "./account-pop-up.vue?vue&type=script&lang=js&"
export * from "./account-pop-up.vue?vue&type=script&lang=js&"
import style0 from "./account-pop-up.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports